import React, { Component } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';

class AllPhotos extends Component {
    state = {  }
    componentDidMount = () => {
        // fetch all photos
    }
    render() {
        // const { PHOTOS } = this.props;
        let PHOTOS = [1, 2, 5, 6, 7]
        return (
            <Box>
                <Typography variant="h5">Photos Utilisateurs</Typography>
                <Grid container spacing={1}>
                    {PHOTOS.map((photo, i) =>
                        <Grid item xs={12} sm={6} md={3}>
                            image {i}
                        </Grid>
                    )}
                </Grid>
            </Box>
        );
    }
}

export default AllPhotos;